module.exports = __webpack_public_path__ + "img/inside-3.ffa1c6a6.png";